import type { ElementType } from 'react';
import { Accordion } from './components/Accordion';
import { AccordionItem } from './components/AccordionItem';
import { AnchorLink } from './components/AnchorLink';
import { AnchorLinkTarget } from './components/AnchorLinkTarget';
import { Container } from './components/Container';
import { ContentHeading } from './components/ContentHeading';
import { Document } from './components/Document';
import { Li } from './components/Li';
import { List } from './components/List';
import { MarketplaceField } from './components/MarketplaceField';
import { NerdTip } from './components/NerdTip';
import { Spacer } from './components/Spacer';
import { Type } from './components/Type';
import { WPBlock } from './components/WPBlock';

export const STRUCTURED_CONTENT_COMPONENTS_BASE: Record<string, ElementType> = {
  Accordion,
  AccordionItem,
  AnchorLink,
  AnchorLinkTarget,
  Container,
  ContentHeading,
  Document,
  Li,
  List,
  MarketplaceField,
  NerdTip,
  Spacer,
  Type,
  WPBlock,
};

export const STRUCTURED_CONTENT_COMPONENTS_LEARN_CONTENT_OVERRIDES: Record<string, ElementType> =
  {};
